import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, adminOnly = false }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div
        data-testid="auth-checking"
        className="min-h-screen flex items-center justify-center bg-brand-bone"
      >
        <div className="w-10 h-10 rounded-full border-2 border-brand-forest border-t-transparent animate-spin" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/calculator" replace />;
  return children;
}
